











































































import Vue from "vue";
import {DonationCase, PrivacyLevel} from "@/interfaces/donation/donationcase/donationCase";
import {CaseEventType} from "@/interfaces/donation/donationcase/caseEvent";

export default Vue.extend({
  props: {
    donationCase: {
      type: Object as () => DonationCase,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    isStandardPrivacy() {
      let dCase: DonationCase = this.donationCase
      return dCase.privacyLevel == PrivacyLevel.STANDARD
    }
  },
  methods: {
    getBirthEvent(donationCase: DonationCase) {
      return donationCase.caseInfo.events.find(caseEvent => caseEvent.type === CaseEventType.BIRTH)
    },
    getFuneralEvent(donationCase: DonationCase) {
      return donationCase.caseInfo.events.find(caseEvent => caseEvent.type === CaseEventType.FUNERAL)
    },
    getDeathEvent(donationCase: DonationCase) {
      return donationCase.caseInfo.events.find(caseEvent => caseEvent.type === CaseEventType.DEATH)
    },
    isnullOrEmpty(val: String): boolean {
      return !val || val.length <= 0
    },
    emptyIfNull(val: String): String {
      return val ? val : ""
    }
  }
});
